import React, { useState } from "react";

const PPTOptionsModal = ({ onClose, onCreateMasked, onCreateUnmasked }) => {
  const [loadingType, setLoadingType] = useState(null); 
  // "masked" | "unmasked" | null

  const stopPropagation = (e) => e.stopPropagation();

  const handleMaskedClick = async () => {
    setLoadingType("masked");
    await onCreateMasked();
    setLoadingType(null);
  };

  const handleUnmaskedClick = async () => {
    setLoadingType("unmasked");
    await onCreateUnmasked();
    setLoadingType(null);
  };

  const isLoading = loadingType !== null;

  return (
    <>
      <div className="modal-backdrop fade show" />

      <div
        className="modal fade show d-block"
        tabIndex="-1"
        role="dialog"
        aria-modal="true"
        style={{ zIndex: 1056 }}
        onClick={!isLoading ? onClose : undefined}
      >
        <div
          className="modal-dialog modal-dialog-centered"
          role="document"
          onClick={stopPropagation}
        >
          <div className="modal-content shadow-sm border-0 rounded-3">
            
            {/* Header */}
            <div className="modal-header bg-light border-bottom">
              <h5 className="modal-title fw-semibold mb-0">
                Create Candidate Profiling
              </h5>
              <button
                type="button"
                className="btn-close"
                disabled={isLoading}
                onClick={onClose}
              />
            </div>

            {/* Body */}
            <div className="modal-body bg-white py-4 px-4">

              {/* Unmasked */}
              <button
                className="btn btn-primary w-100 mb-3 d-flex align-items-center justify-content-center gap-2"
                onClick={handleUnmaskedClick}
                disabled={isLoading}
              >
                {loadingType === "unmasked" ? (
                  <>
                    <span className="spinner-border spinner-border-sm"></span>
                    Creating PPT...
                  </>
                ) : (
                  <>
                    <i className="fa-solid fa-file-powerpoint"></i>
                    Create Unmasked Profiling
                  </>
                )}
              </button>

              {/* Masked */}
              <button
                className="btn btn-outline-secondary w-100 d-flex align-items-center justify-content-center gap-2"
                onClick={handleMaskedClick}
                disabled={isLoading}
              >
                {loadingType === "masked" ? (
                  <>
                    <span className="spinner-border spinner-border-sm"></span>
                    Creating PPT...
                  </>
                ) : (
                  <>
                    <i className="fa-solid fa-user-secret"></i>
                    Create Masked Profiling
                  </>
                )}
              </button>

            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PPTOptionsModal;
